import { FC, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import CheckIcon from '@mui/icons-material/Check';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { TableCell, TableRow } from '@mui/material';
import cn from 'classnames';

import AdminSupplementStatusDot from '@components/AdminSupplementStatusDot/AdminSupplementStatusDot';
import { IAdminSupplementInquiryDetailsEntry } from '@interfaces/adminSupplements';
import { adminInquiryEntryDetailsActiveIdSelector } from '@store/features/adminInquiries/inquiryEntryDetails/selectors';

import { ITableGridDetailsRowProps } from './TableGridDetailsRow.interface';

import './style.scss';

const TableGridDetailsRow: FC<ITableGridDetailsRowProps> = ({
  className,
  inquiryEntry,
  isSupplementaryRow,
  onClick,
}) => {
  const { t } = useTranslation();

  const adminSupplementInquiryActiveId = useSelector(adminInquiryEntryDetailsActiveIdSelector);
  const isActive = inquiryEntry.entryInquiryId === adminSupplementInquiryActiveId;

  const handleClick = useCallback((): void => {
    onClick(inquiryEntry);
  }, [onClick, inquiryEntry]);

  return (
    <TableRow className={cn('admin-inquiries-details', className)}>
      <TableCell />
      <TableCell className="admin-inquiries-details__circle-box">
        <AdminSupplementStatusDot value={inquiryEntry.adminSupplementInquiryStatusId} />
      </TableCell>
      <TableCell className="admin-inquiries-details__text-box">
        <div
          onClick={handleClick}
          className={cn('admin-inquiries-details__name', {
            'admin-inquiries-details__name_active': isActive,
          })}
        >
          {inquiryEntry.name}
        </div>

        {isSupplementaryRow && !(inquiryEntry as IAdminSupplementInquiryDetailsEntry).isActive && (
          <div className="admin-inquiries-details__deactivated">
            {t('dietarySupplementInquiry.deactivated')}
          </div>
        )}
      </TableCell>
      <TableCell className="admin-inquiries-details__icon-box">
        {inquiryEntry.needsAdminResponse ? (
          <HelpOutlineIcon color="success" />
        ) : (
          <CheckIcon color="success" />
        )}
      </TableCell>
      <TableCell />
    </TableRow>
  );
};

export default TableGridDetailsRow;
